export const isCardElementInvalid = (cardElement) => {
    return !cardElement || cardElement._empty || cardElement._invalid;
};
